import { render, staticRenderFns } from "./AlipayWithholdLaunch.vue?vue&type=template&id=11b1c71b&scoped=true"
import script from "./AlipayWithholdLaunch.vue?vue&type=script&lang=js"
export * from "./AlipayWithholdLaunch.vue?vue&type=script&lang=js"
import style0 from "./AlipayWithholdLaunch.vue?vue&type=style&index=0&id=11b1c71b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1c71b",
  null
  
)

export default component.exports